/* global axios */
import ApiClient from './ApiClient';

class OpportunitiesAPI extends ApiClient {
  constructor() {
    super('opportunities', { accountScoped: true });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  kanban(params = {}) {
    return axios.get(`${this.url}/kanban`, { params });
  }

  // Onda 2: planilha do funil (port do WebScale). pipelineIds vazio = todos.
  exportData(pipelineIds = null, filters = {}) {
    return axios.post(`${this.url}/export_data`, {
      ...filters,
      pipeline_ids: pipelineIds || undefined,
    });
  }

  // Origens de lead gerenciáveis pela conta (CRUD sem deploy) — /crm_settings
  getCrmSettings() {
    return axios.get(this.url.replace(/opportunities$/, 'crm_settings'));
  }

  // payload: { lead_sources: [...] } e/ou { procedures: [{name, value}] }
  updateCrmSettings(payload) {
    return axios.patch(
      this.url.replace(/opportunities$/, 'crm_settings'),
      payload
    );
  }

  // Transferir card para outro pipeline (move, preservando tudo) — 868ka5bvq
  transfer(id, targetPipelineId) {
    return axios.post(`${this.url}/${id}/transfer`, {
      target_pipeline_id: targetPipelineId,
    });
  }

  moveStage(id, { pipeline_stage_id, kanban_order }) {
    return axios.patch(`${this.url}/${id}/move_stage`, {
      pipeline_stage_id,
      kanban_order,
    });
  }

  // Lista de Espera: "Agendado" — fecha o card na fila e move/cria no pipeline principal.
  waitlistSchedule(id) {
    return axios.post(`${this.url}/${id}/waitlist_schedule`);
  }

  archive(id) {
    return axios.patch(`${this.url}/${id}/archive`);
  }

  unarchive(id) {
    return axios.patch(`${this.url}/${id}/unarchive`);
  }

  getActivities(opportunityId) {
    return axios.get(`${this.url}/${opportunityId}/activities`);
  }

  createActivity(opportunityId, data) {
    return axios.post(`${this.url}/${opportunityId}/activities`, {
      opportunity_activity: data,
    });
  }

  updateActivity(opportunityId, activityId, data) {
    return axios.patch(
      `${this.url}/${opportunityId}/activities/${activityId}`,
      { opportunity_activity: data }
    );
  }

  deleteActivity(opportunityId, activityId) {
    return axios.delete(
      `${this.url}/${opportunityId}/activities/${activityId}`
    );
  }

  registerFollowup(id, { message } = {}) {
    return axios.post(`${this.url}/${id}/register_followup`, { message });
  }

  // Etiquetas do card (substitui a lista inteira, como na conversa)
  getLabels(id) {
    return axios.get(`${this.url}/${id}/labels`);
  }

  updateLabels(id, labels) {
    return axios.post(`${this.url}/${id}/labels`, { labels });
  }
}

export default new OpportunitiesAPI();
